import React, { useEffect, useRef, useState, useMemo } from 'react';
import {
  Modal,
  Button,
  Form,
  InputNumber,
  Nav,
  Grid,
  Row,
  Col,
  Schema,
  toaster,
  Message,
  InputGroup,
  Divider,
  Toggle,
} from 'rsuite';
import { FaTrash, FaImage, FaPizzaSlice } from 'react-icons/fa';
import api from '../../../../../../services/api';
import { ImageUploader } from '../../../../../../components/ImageUploader';
import { toastSuccess, toastError } from '../../../../../../toasts';
import { IMAGES_PATH } from '../../../../../../utils/imagesPath';
import * as S from './styles';
import RModal from '../../../../../../components/Rsuite/Modal';

const { StringType } = Schema.Types;
const model = Schema.Model({
  descricao: StringType().isRequired('A descrição é obrigatória.'),
});

export function CreateEditBorderModal({
  modalOpen = false,
  toggleModal = () => {},
  handleSetBorders = () => {},
  borders = [],
  tamanhos = [],
  currentBorder = {},
  handleSetCurrentBorder = () => {},
  idGrupo = '',
  idEmpresa = '',
  getBorders = () => {},
  selecteds,
}) {
  const [formValue, setFormValue] = useState({
    descricao: '',
    codigo: '',
    tamanhos: [],
  });

  const [activeTab, setActiveTab] = useState('dados');
  const [deleteModal, setDeleteModal] = useState(false);
  const [loading, setLoading] = useState(false);
  const formRef = useRef();

  const isEditMode = !!currentBorder?.id || !!currentBorder?.Id;

  useEffect(() => {
    if (modalOpen) {
      setActiveTab('dados');

      const existingTamanhos =
        currentBorder?.tamanhos || currentBorder?.PrecosTamanhos || [];

      const initialSizes = tamanhos.map((tam) => {
        let existingSize = existingTamanhos.find(
          (t) => String(t.id || t.idTamanho || t.IdTamanho) === String(tam.Id),
        );

        if (!existingSize) {
          existingSize = existingTamanhos.find(
            (t) =>
              String(t.descricao || t.Descricao).toLowerCase() ===
                String(tam.Descricao).toLowerCase() &&
              Number(t.preco ?? t.Preco ?? 0) > 0,
          );
        }

        return {
          idTamanho: tam.Id,
          descricao: tam.Descricao,
          apresenta: existingSize
            ? Number(existingSize.Apresenta ?? existingSize.apresenta ?? 1)
            : 1,
          preco: existingSize
            ? Number(existingSize.preco ?? existingSize.Preco ?? 0)
            : 0,
          precoDesconto: existingSize
            ? Number(
                existingSize.precoDesconto ?? existingSize.PrecoDesconto ?? 0,
              )
            : 0,
        };
      });

      setFormValue({
        descricao: currentBorder?.descricao || currentBorder?.Descricao || '',
        codigo: currentBorder?.codigo || currentBorder?.CodigoPDV || 0,
        tamanhos: initialSizes,
      });
    }
  }, [modalOpen, currentBorder, tamanhos]);

  const handleSubmit = async () => {
    if (!formRef.current.check()) {
      toaster.push(
        <Message type="error">Verifique os campos obrigatórios.</Message>,
        { placement: 'topCenter' },
      );
      return;
    }

    setLoading(true);

    try {
      const currentId = currentBorder?.id || currentBorder?.Id;

      const borderData = {
        descricao: formValue.descricao,
        codigo: formValue.codigo ? Number(formValue.codigo) : 0,
        tamanhos: formValue.tamanhos.map((t) => ({
          ...t,
          Apresenta: t.apresenta ?? 1,
        })),
      };

      if (isEditMode) {
        if (idGrupo) {
          await api.patch(`/produto/alterar/${currentId}`, {
            Descricao: borderData.descricao,
            PrecosTamanhos: borderData.tamanhos,
            CodigoPDV: +borderData.codigo || 0,
          });
        }

        handleSetBorders(
          borders.map((b) =>
            (b.id || b.Id) === currentId ? { ...b, ...borderData } : b,
          ),
        );
        toastSuccess('Borda atualizada com sucesso!');
      } else {
        if (idGrupo) {
          const newBorderProduct = {
            Descricao: borderData.descricao,
            CodigoPDV: +borderData.codigo || 0,
            Unidade: 'UN',
            TipoProduto: 'BORDA',
            Grupo: idGrupo,
            IdEmpresa: idEmpresa,
            PrecosTamanhos: borderData.tamanhos,
            Composicao: '',
            PrecoVenda: 0,
            MontagemPrato: 0,
            Fracionado: 0,
            KgInicial: 0,
            FreteGratis: 0,
            Sequencia: 0,
            QtdMinima: 0,
          };

          await api.post('produto/criar', newBorderProduct);
          setTimeout(() => getBorders(), 500);
        } else {
          handleSetBorders([...borders, borderData]);
        }
        toastSuccess('Borda criada com sucesso!');
      }

      handleClose();
    } catch (error) {
      console.error(error);
      toastError('Erro ao salvar borda.');
    } finally {
      setLoading(false);
    }
  };

  const handleDelete = async () => {
    setLoading(true);
    const currentId = currentBorder?.id || currentBorder?.Id;
    try {
      await api.patch(`produto/alterar/${currentId}`, { Ativo: false });
      handleSetBorders(borders.filter((b) => (b.id || b.Id) !== currentId));
      setDeleteModal(false);
      handleClose();
      toastSuccess('Borda removida!');
    } catch (err) {
      toastError('Erro ao excluir borda.');
    } finally {
      setLoading(false);
    }
  };

  const handleClose = () => {
    setFormValue({ descricao: '', codigo: '', tamanhos: [] });
    handleSetCurrentBorder({});
    toggleModal(false);
  };

  const saveImage = async (imagem) => {
    try {
      if (imagem.size / 1024 / 1024 > 1) {
        toastError('Imagem muito grande (Max 1MB).');
        return;
      }
      const currentId = currentBorder?.id || currentBorder?.Id;
      const fd = new FormData();
      fd.append('IdEmpresa', idEmpresa);
      fd.append('Id', currentId);
      fd.append('image', imagem);

      const res = await api.post('produto/alterarFoto', fd);
      toastSuccess('Imagem salva!');
      getBorders();
      handleSetCurrentBorder({ ...currentBorder, Imagem: res.data?.Imagem });
    } catch (err) {
      toastError('Erro ao salvar imagem.');
    }
  };

  const removeImage = async () => {
    try {
      const currentId = currentBorder?.id || currentBorder?.Id;
      const fd = new FormData();
      fd.append('IdEmpresa', idEmpresa);
      fd.append('ColunaImagem', 'Imagem');
      fd.append('Id', currentId);
      await api.post('produto/excluirFoto', fd);
      toastSuccess('Imagem removida!');
      getBorders();
      handleSetCurrentBorder({ ...currentBorder, Imagem: null });
    } catch (err) {
      toastError('Erro ao remover imagem.');
    }
  };

  const handlePriceChange = (index, field, value) => {
    setFormValue((prev) => {
      const newTamanhos = [...prev.tamanhos];
      newTamanhos[index] = {
        ...newTamanhos[index],
        [field]: value,
      };
      return { ...prev, tamanhos: newTamanhos };
    });
  };

  const tamanhosVisiveis = useMemo(() => {
    if (!selecteds || !Array.isArray(selecteds) || selecteds.length === 0)
      return [];

    return formValue.tamanhos.filter((tam) =>
      selecteds.some((x) => {
        const isMatchId =
          String(x.Id) === String(tam.idTamanho) ||
          String(x.IdTamanho) === String(tam.idTamanho);
        const isAtivo =
          'Ativo' in x
            ? +x.Ativo === 1
            : true;

        return isMatchId && isAtivo;
      }),
    );
  }, [formValue.tamanhos, selecteds]);

  return (
    <>
      <RModal
        open={modalOpen}
        onClose={handleClose}
        size="md"
        title={isEditMode ? 'Editar Borda' : 'Nova Borda'}
        bodyStyle={{ overflow: 'hidden', padding: 0 }}
      >
        <S.TabsContainer>
          <Nav
            appearance="subtle"
            activeKey={activeTab}
            onSelect={setActiveTab}
          >
            <Nav.Item eventKey="dados">Dados Básicos</Nav.Item>
            <Nav.Item eventKey="precos">Preços por Tamanho</Nav.Item>
          </Nav>
        </S.TabsContainer>

        <S.FormContainer>
          <Form
            fluid
            ref={formRef}
            model={model}
            formValue={formValue}
            onChange={setFormValue}
            style={{ width: '100%' }}
          >
            {activeTab === 'dados' && (
              <Grid fluid style={{ padding: 0 }}>
                <Row gutter={24}>
                  <Col xs={24} sm={16}>
                    <Form.Group controlId="descricao">
                      <Form.ControlLabel>Descrição da Borda</Form.ControlLabel>
                      <Form.Control
                        name="descricao"
                        placeholder="Ex: Catupiry Original"
                      />
                    </Form.Group>

                    <Form.Group controlId="codigo">
                      <Form.ControlLabel>
                        Código PDV (Opcional)
                      </Form.ControlLabel>
                      <Form.Control name="codigo" placeholder="Ex: 105" />
                    </Form.Group>
                  </Col>

                  <Col
                    xs={24}
                    sm={8}
                    style={{ display: 'flex', flexDirection: 'column' }}
                  >
                    <Form.ControlLabel style={{ marginBottom: 8 }}>
                      Imagem
                    </Form.ControlLabel>
                    {isEditMode ? (
                      <div style={{ width: '100%', height: 120 }}>
                        <ImageUploader
                          save={saveImage}
                          remove={removeImage}
                          src={
                            currentBorder?.Imagem || currentBorder?.imagem
                              ? IMAGES_PATH +
                                (currentBorder.Imagem || currentBorder.imagem)
                              : ''
                          }
                        />
                      </div>
                    ) : (
                      <S.ImageUploadContainer title="A imagem só pode ser adicionada após cadastrar a borda.">
                        <FaImage size={24} />
                        <span>Salve para enviar imagem</span>
                      </S.ImageUploadContainer>
                    )}
                  </Col>
                </Row>
              </Grid>
            )}

            {activeTab === 'precos' && (
              <S.PricesContainer>
                {tamanhosVisiveis.length === 0 ? (
                  <S.EmptyState>
                    Nenhum tamanho ativo selecionado para este grupo.
                  </S.EmptyState>
                ) : (
                  tamanhosVisiveis.map((tam) => {
                    const realIndex = formValue.tamanhos.findIndex(
                      (t) => t.idTamanho === tam.idTamanho,
                    );

                    return (
                      <S.PriceRow key={tam.idTamanho}>
                        <div className="label-col">
                          <FaPizzaSlice
                            color="#ccc"
                            size={14}
                            style={{ marginRight: 8 }}
                          />
                          {tam.descricao}
                        </div>

                        <div className="inputs-wrapper">
                          <S.ShowBorderContainer className="input-col">
                            <label>Exibir borda</label>
                            <Toggle
                              checked={!!tam.apresenta}
                              onChange={(val) =>
                                handlePriceChange(realIndex, 'apresenta', val ? 1 : 0)
                              }
                              size="md"
                              checkedChildren="Sim"
                              unCheckedChildren="Não"
                            />
                          </S.ShowBorderContainer>

                          {!!tam.apresenta ? (
                            <>
                              <div className="input-col">
                                <label>Preço Padrão</label>
                                <InputGroup inside>
                                  <InputGroup.Addon>R$</InputGroup.Addon>
                                  <InputNumber
                                    value={tam.preco}
                                    onChange={(val) =>
                                      handlePriceChange(realIndex, 'preco', val)
                                    }
                                    min={0}
                                    step={0.5}
                                  />
                                </InputGroup>
                              </div>

                              <div className="input-col">
                                <label>Preço Promocional</label>
                                <InputGroup inside>
                                  <InputGroup.Addon>R$</InputGroup.Addon>
                                  <InputNumber
                                    value={tam.precoDesconto}
                                    onChange={(val) =>
                                      handlePriceChange(
                                        realIndex,
                                        'precoDesconto',
                                        val,
                                      )
                                    }
                                    min={0}
                                    step={0.5}
                                  />
                                </InputGroup>
                              </div>
                            </>
                          ) :
                            <>
                              <div className="input-col"></div>
                              <div className="input-col"></div>
                            </>
                          }
                        </div>
                      </S.PriceRow>
                    );
                  })
                )}
              </S.PricesContainer>
            )}
          </Form>
        </S.FormContainer>

        <Divider style={{ margin: 0 }} />

        <S.ModalFooter>
          <div>
            {isEditMode && (
              <Button
                onClick={() => setDeleteModal(true)}
                appearance="subtle"
                color="red"
                startIcon={<FaTrash />}
              >
                Excluir
              </Button>
            )}
          </div>
          <S.FooterActions>
            <Button onClick={handleClose} appearance="subtle">
              Cancelar
            </Button>
            <Button
              onClick={handleSubmit}
              appearance="primary"
              loading={loading}
            >
              {isEditMode ? 'Salvar Alterações' : 'Cadastrar Borda'}
            </Button>
          </S.FooterActions>
        </S.ModalFooter>
      </RModal>

      {deleteModal && (
        <Modal
          open={deleteModal}
          onClose={() => setDeleteModal(false)}
          size="xs"
          backdrop="static"
        >
          <Modal.Header>
            <Modal.Title>Excluir Borda</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            Tem certeza que deseja excluir a borda{' '}
            <strong>
              {currentBorder.Descricao || currentBorder.descricao}
            </strong>
            ?
            <br />
            Esta ação não pode ser desfeita.
          </Modal.Body>
          <Modal.Footer>
            <Button onClick={() => setDeleteModal(false)} appearance="subtle">
              Cancelar
            </Button>
            <Button
              onClick={handleDelete}
              appearance="primary"
              color="red"
              loading={loading}
            >
              Confirmar Exclusão
            </Button>
          </Modal.Footer>
        </Modal>
      )}
    </>
  );
}
